var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"block b--flex b--justify ovh"},[_c('ui-navigation'),_c('transition',{attrs:{"name":"view-fade","mode":"out-in"}},[_c('router-view')],1),_c('ui-sidebar'),_c('ui-modal')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }